import { hostViewportHeight } from '$lib/Stores/stores';

export const handleViewportHeight = () => {
    if (window.parent == window) {
        return;
    }

    const isViewportHeightMessage = (
        data: unknown,
    ): data is { type: 'viewportHeight'; viewportHeight: number } => {
        return (
            !!data &&
            typeof data === 'object' &&
            'type' in data &&
            'viewportHeight' in data &&
            data.type === 'viewportHeight' &&
            typeof data.viewportHeight === 'number'
        );
    };

    window.addEventListener('message', (event) => {
        if (isViewportHeightMessage(event.data)) {
            hostViewportHeight.set(event.data.viewportHeight);
        }
    });

    window.parent.postMessage({ type: 'embed-ready' }, '*');
};
